import { c as _c } from "react/compiler-runtime";
interface BackgroundImages {
  mobile: string;
  tablet: string;
  desktop: string;
}
interface Props {
  background: BackgroundImages;
  children: React.ReactNode;
}
export default function MovieHero(t0) {
  const $ = _c(12);
  const {
    background,
    children
  } = t0;
  const hasBg = background.mobile || background.desktop || background.tablet;
  const desktopSrc = background.desktop || background.tablet || background.mobile;
  const tabletSrc = background.tablet || background.desktop;
  const mobileSrc = background.mobile || background.tablet || background.desktop;
  let t1;
  if ($[0] !== desktopSrc || $[1] !== hasBg || $[2] !== mobileSrc || $[3] !== tabletSrc) {
    t1 = hasBg && <picture className="absolute inset-0 w-full h-full">{mobileSrc && <source media="(max-width: 767px)" srcSet={mobileSrc} />}{tabletSrc && <source media="(min-width: 768px) and (max-width: 1023px)" srcSet={tabletSrc} />}<img src={desktopSrc} alt="" className="absolute inset-0 w-full h-full object-cover object-top" fetchPriority="high" decoding="async" /></picture>;
    $[0] = desktopSrc;
    $[1] = hasBg;
    $[2] = mobileSrc;
    $[3] = tabletSrc;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="absolute inset-0 bg-gradient-to-b from-transparent via-transparent to-[#0d0d1b]" />;
    t3 = <div className="absolute inset-0 bg-gradient-to-l from-[#0d0d1b]/80 via-transparent to-transparent" />;
    $[5] = t2;
    $[6] = t3;
  } else {
    t2 = $[5];
    t3 = $[6];
  }
  let t4;
  if ($[7] !== children) {
    t4 = <div className="relative w-full min-h-[65vh] sm:min-h-[60vh] md:aspect-[1920/900] md:min-h-[46.875vw] z-10 flex items-start">{children}</div>;
    $[7] = children;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t1 || $[10] !== t4) {
    t5 = <section className="relative w-full overflow-hidden"><div className="relative min-h-[65vh] sm:min-h-[60vh] md:aspect-[1920/900] md:min-h-[46.875vw] z-10 flex items-start">{t1}{t2}{t3}{t4}</div></section>;
    $[9] = t1;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  return t5;
}